import { Table, message, Button, Row, Col, Pagination, Image } from "antd";
import { EditOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import SearchProps from "../../../component/SearchProps";
import dayjs from "dayjs";
import axiosInstance from "../../../utils/axios";
import { FormatVND } from "../../../utils/format";

export default function VoucherManage() {
  const [categories, setCategories] = useState([]);
  const [pagination, setPagination] = useState({
    page: 1,
    pageSize: 10,
  });

  const fetchCategories = async () => {
    await axiosInstance.get(`/voucher/getAll`, {params: pagination})
      .then((res) => {
        const data = res?.data;
        setCategories(data);
      })
      .catch(() => message.error("Error server!"));
  };

  useEffect(() => {
    fetchCategories();
  }, [pagination]);

  const columns = [
    {
      title: <div>ID</div>,
      key: "voucher_id",
      dataIndex: "voucher_id",
      width: 100,
      sorter: (a, b) => a.voucher_id - b.voucher_id,
      render: (_, record) => <div>{record?.voucher_id}</div>,
    },
    {
      title: <div>Tên</div>,
      key: "voucher_name",
      dataIndex: "voucher_name",
      width: 150,
      ...SearchProps("voucher_name"),
      render: (_, record) => <div>{record?.voucher_name}</div>,
    },
    {
      title: <div>Mã giảm giá</div>,
      key: "voucher_code",
      dataIndex: "voucher_code",
      width: 150,
      ...SearchProps("voucher_code"),
      render: (_, record) => <div>{record?.voucher_code}</div>,
    },
    {
      title: <div>Giảm</div>,
      key: "voucher_price",
      dataIndex: "voucher_price",
      width: 150,
      ...SearchProps("voucher_price"),
      render: (_, record) => <div>{FormatVND(record?.voucher_price)}</div>,
    },
    {
      title: <div>Mức tối thiểu</div>,
      key: "voucher_level",
      dataIndex: "voucher_level",
      width: 150,
      ...SearchProps("voucher_level"),
      render: (_, record) => <div>{FormatVND(record?.voucher_level)}</div>,
    },
    {
      title: <div className={"base-table-cell-label "}>Ngày tạo</div>,
      key: "create_at",
      dataIndex: "create_at",
      width: 100,
      sorter: (a, b) => dayjs(a.create_at) - dayjs(b.create_at),
      render: (_, record) => {
        return (
          <div className={"cursor-pointer text-[14px] font-normal"}>
            <span className={"!inline-block min-w-[100px]"}>
              {dayjs(record?.create_at).format("DD/MM/YYYY")}
            </span>
          </div>
        );
      },
    },
    {
      key: "operation",
      dataIndex: "operation",
      width: 50,
      render: (_, record) => {
        return (
          <Link
            to={`/admin/quan-ly-ma-giam-gia/${record?.voucher_id}`}
            className={"text-[var(--blue)]"}
          >
            <EditOutlined />
          </Link>
        );
      },
    },
  ];

  return (
    <>
      <div>
        <Row gutter={10} className={"mb-[8px]"}>
          <Col flex={1}>
            <div className={"text-[20px] font-medium"}>Danh mục cha</div>
          </Col>
          <Col>
            <Link to={"/admin/quan-ly-ma-giam-gia/tao-moi"}>
              <Button type={"primary"} onClick={() => {}}>
                Tạo
              </Button>
            </Link>
          </Col>
        </Row>
      </div>
      <div className="w-full h-full mt-5 pb-20 relative">
        <Table
          className={"custom-table"}
          dataSource={categories?.data}
          columns={columns}
          pagination={false}
          scroll={{ x: 'max-content' }}
        />
        <Pagination
          className="flex justify-center absolute inset-x-0 bottom-10"
          current={pagination.page}
          total={categories?.total}
          pageSize={pagination.pageSize}
          showSizeChanger
          onChange={(p, ps)=> {
            setPagination({
              page: p,
              pageSize: ps
            })
          }}
        />
      </div>
    </>
  );
}
